import fetch, { fetchConfig } from '@/hooks/fetch';
import actions from '../constants';

export default {
  useFetchDatasetPermissions: ({ category, code }, readStatus) => fetch.useFetchDispatch(
    actions.FETCH_DATASET_PERMISSIONS,
    readStatus,
    { category, code },
    fetchConfig([category, code, readStatus]),
  ),
};
